import React from "react";
import { GlobalTableActionButton } from "../../../../global/GlobalTableActionButton";
import { resolveVisitorStatus } from "../../utils/visitorStatus";
import { VISITOR_STATUS_LABELS } from "../../utils/visitorStatuses";
import { handlePrintVisitorSlipStub } from "../../utils/visitorSlip";

export default function VisitorActions({
  visitor,
  permissions,
  onView,
  onEdit,
  onDelete,
  onExit,
  onSlip,
  compact = false,
}) {
  if (!visitor) return null;

  const status = resolveVisitorStatus(visitor);
  const canExit =
    permissions?.canExit &&
    status === VISITOR_STATUS_LABELS.INSIDE &&
    Boolean(onExit);

  return (
    <div className="ub-table-actions">
      {onView ? (
        <GlobalTableActionButton action="view" onClick={() => onView(visitor)} />
      ) : null}
      {permissions?.canEdit ? (
        <GlobalTableActionButton action="edit" onClick={() => onEdit?.(visitor)} />
      ) : null}
      {permissions?.canSlip ? (
        <GlobalTableActionButton
          action="slip"
          title={compact ? "Print slip" : "Print visitor slip"}
          onClick={() => {
            // TODO: Generate visitor slip PDF and print after saving visitor.
            handlePrintVisitorSlipStub();
            onSlip?.(visitor);
          }}
        />
      ) : null}
      {canExit && onExit ? (
        <GlobalTableActionButton action="exit" onClick={() => onExit(visitor)} />
      ) : null}
      {permissions?.canDelete ? (
        <GlobalTableActionButton action="delete" onClick={() => onDelete?.(visitor)} />
      ) : null}
    </div>
  );
}
